(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoto-home-audio-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-yoto-audio-world]');

    roots.forEach((root) => {
      const railGroups = root.querySelectorAll('[data-yoto-rail-group]');

      railGroups.forEach((group) => {
        const rail = group.querySelector('[data-yoto-audio-rail]');
        const prev = group.querySelector('[data-yoto-rail-prev]');
        const next = group.querySelector('[data-yoto-rail-next]');

        if (!rail || !prev || !next) {
          return;
        }

        const getAmount = () => {
          const card = rail.querySelector('.yoto-audio-world__card');
          const styles = window.getComputedStyle(rail);
          const gap = parseFloat(styles.columnGap || styles.gap || 0);

          if (!card) {
            return rail.clientWidth * 0.85;
          }

          if (window.innerWidth < 750) {
            return (card.getBoundingClientRect().width + gap) * 1.2;
          }

          return (card.getBoundingClientRect().width + gap) * 4;
        };

        const update = () => {
          const max = Math.max(0, rail.scrollWidth - rail.clientWidth - 4);
          prev.disabled = rail.scrollLeft <= 4;
          next.disabled = rail.scrollLeft >= max;
        };

        prev.addEventListener('click', () => {
          rail.scrollBy({ left: -getAmount(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          rail.scrollBy({ left: getAmount(), behavior: 'smooth' });
        });

        rail.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
